<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="语言名称" prop="word">
				<el-input v-model="query.word" placeholder="请输入语言名称" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
			<el-form-item label="选择站点" prop="siteId">
				<el-select v-model="query.siteId">
					<el-option v-for="item in countries" :key="item.id" :value="item.id"
						:label="item.siteName"></el-option>
				</el-select>
			</el-form-item>
		</template>
		<template slot="btns">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增语言
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column label="语言名称" align="center" prop="languageName" />
			<el-table-column label="关联站点" align="center" prop="countryList">
				<template slot-scope="{ row }">
					{{ row.siteNameList ? row.siteNameList.length : "0" }}
				</template>
			</el-table-column>
			<el-table-column label="创建时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="关联产品" align="center" prop="productNum" />
			<el-table-column label="操作" align="center" width="140">
				<template slot-scope="{ row }">
					<el-link style="margin-right: 10px" :underline="false" type="primary" @click="handleEdit(row)">
						编辑
					</el-link>
					<el-link :underline="false" type="danger" @click="handleDel(row)">
						删除
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, del, countryList } from "@/api/language";
import listMixin from '@/mixins/list';
import { page as sitePage } from "@/api/site";
export default {
	data() {
		return {
			// 查询参数
			query: {
				word: "",
				country: "",
				siteId:""
			},
			countries: []
		};
	},
	mixins: [listMixin],
	mounted() {
		this.getCountryList();
	},
	methods: {
		getCountryList() {
			sitePage({
                pageNum: 1,
                pageSize: 100
            }).then(({ code, data, message }) => {
                if (code == 200) {
                    this.countries = data.records;
                } else {
                    this.$message.error(message);
                }
            })  
			// countryList().then(({ code, data, message }) => {
			// 	if (code == 200) {
			// 		this.countries = data;
			// 	} else {
			// 		this.$message.error(message);
			// 	}
			// })
		},
		search() {
			this.loading = true;
			const params = {
				...this.query
			};
			page(params).then(({ code, data, message }) => {
				if (code == 200) {
					this.tableData = data.records;
					this.total = data.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/language/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/language/form", query: { id: row.id } });
		},
		handleDel(row) {
			this.$confirm("是否删除该语言?", "提示", {
				type: "warning",
			})
				.then(() => {
					del(row.id).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
	},
};
</script>